export const i18nContentHash = 'f4e962a'
